import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import 'antd/dist/antd.css';
import 'antd/lib/avatar/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/card/style/css';
import 'antd/lib/col/style/css';
import 'antd/lib/form/style/css';
import 'antd/lib/icon/style/css';
import 'antd/lib/list/style/css';
import 'antd/lib/modal/style/css';
import 'antd/lib/popconfirm/style/css';
import 'antd/lib/progress/style/css';
import 'antd/lib/result/style/css';
import 'antd/lib/row/style/css';
import 'antd/lib/skeleton/style/css';
import 'antd/lib/spin/style/css';
import 'antd/lib/tabs/style/css';
import 'antd/lib/table/style/css';
import 'antd/lib/tooltip/style/css';

import 'static/css/theme.components.min.css';
import 'static/css/theme.layout.min.css';
import 'static/css/theme.darkblue.min.css';
import 'static/css/theme.pricing.min.css';
import 'static/css/theme.login.min.css';
import 'static/css/app.css';
import 'static/css/animations.css';

import Header from 'containers/layout/HeaderContainer';
import Footer from './layout/Footer';
import Sidebar from 'containers/layout/SidebarContainer';
import Main from 'containers/layout/MainContainer';
import { LoaderOverlay } from 'vdlib';

import { history } from 'data/Store';
import { initLocale as initYupLocale } from 'data/i18n/yup';

import wallpaper from 'static/img/parts_wall.jpg';

const App = ({
  children,
  initialLoadingComplete: inited,
  locale,
  onAppInit,
  user,
}) => {
  // Run onAppInit on mount
  React.useEffect(() => {
    onAppInit();
    initYupLocale();
  }, []); //eslint-disable-line

  // redirect to login if user becomes null
  React.useEffect(() => {
    if (!user) history.push({ pathname: '/login' });
  }, [user]);

  const wrapperClassName = !user ? 'unauthenticated' : '';

  return (
    <div className={`page-wrapper ${wrapperClassName}`}>
      <div
        className="app-bg"
        style={{
          backgroundImage: `url(${wallpaper})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <Header user={user} />

      <div className="clearfix" />

      <div className="page-container">
        <CSSTransitionGroup
          transitionName="sidebar-wrap"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
          component={'div'}
        >
          {inited && user != null ? <Sidebar /> : false}
        </CSSTransitionGroup>

        <div className={`fade ${inited ? 'show' : ''}`}>
          {inited && user != null ? (
            <Main>{children}</Main>
          ) : inited ? (
            <div className="login">
              <div className="logo" />
              <div className="content">
                {children}
                <div className="clearfix" />
              </div>
            </div>
          ) : (
            false
          )}
        </div>

        <LoaderOverlay className="app-loader" loading={!inited} />
      </div>

      <Footer />
    </div>
  );
};

export default App;
